<template>
  <div class="set-working-day">
    <div class="fn-clear">
      <div class="fn-left"> <el-button type="primary" @click="fnRefreshCorrectTime()">刷新批改工作时间</el-button></div>
      <div class="fn-left"><p class="warning_tips">*设置后请点击「刷新批改工作日时间」</p></div>
      <el-button type="warning" @click="fnSetCurrentMonth()">快捷设置当月</el-button>

    </div>

    <el-calendar v-model="date" class="calandar_new">
      <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
      <template
        slot="dateCell"
        slot-scope="{date, data}"
      >
        <div v-if="data.type == 'current-month'">
          <p style="margin-bottom:8px">{{ data.current }}{{ data.day }} </p>
          <el-radio-group v-if="calandarData[data.day] " v-model="calandarData[data.day].check" size="small" @change="setCalandarType(data.day)">
            <el-radio label="1" class="normal"><span>周中工作日</span></el-radio>
            <el-radio label="2" class="week"><span>周末工作日</span></el-radio>
            <el-radio label="3" class="none">无</el-radio>
          </el-radio-group>
          <el-checkbox v-if="calandarData[data.day] && ['1','96','311','62','338'].indexOf(userInfo.company_id) > -1" v-model="calandarData[data.day].is_holiday" true-label="1" false-label="0" @change="setIsHoliday(data.day,$event)">假期</el-checkbox>
          <el-button v-if="!calandarData[data.day]" size="mini" type="primary" @click="fnSetNewCalandarType(data.day)">设置</el-button>
        </div>

        <!-- <radio :value="true" name="setting" label="formal_work">常规工作日</radio>
        <el-radio :value="false" name="setting" label="week_work">周末工作日</radio>
        <el-radio :value="false" name="setting" label="clear">无</radio> -->
      </template>
    </el-calendar>
  </div>
</template>
<script>

var moment = require('moment')
var async = require('async')
export default {
  name: 'SetWorkingDay',
  data() {
    return {
      calandarData: {},
      date: new Date(),
      currentYear: new Date().getFullYear(),
      currentMonth: moment().format('MM'),
      holidayJson: {},
      userInfo: localStorage.userInfo
        ? JSON.parse(localStorage.userInfo)
        : {}
    }
  },
  watch: {
    date(newVal) {
      this.currentMonth = moment(this.date).format('MM')
      this.currentYear = this.date.getFullYear()
      try {
        this.holidayJson = require(`@/assets/json/${this.currentYear}_holiday.json`)
      } catch (error) {
        this.holidayJson = {}
      }
    },
    currentYear() {
      this.getCalendarData()
    }
  },
  mounted() {

  },
  created() {
    this.getCalendarData()
  },
  methods: {
    getCalendarData() {
      this.$http.getCalendarData({ year: this.currentYear }).then(res => {
        for (var i in res.data) {
          res.data[i].check = this.filterStatus(res.data[i])
        }
        this.calandarData = res.data
      })
    },
    filterStatus(val) {
      if (val.formal_work == '1') {
        return '1'
      }
      if (val.week_work == '1') {
        return '2'
      }
      if (val.week_work == '0' || val.formal_work == '0') {
        return '3'
      }
    },
    filterStuatsRestore: function(val) {
      var obj = Object.assign({}, val)
      obj.formal_work = 0
      obj.week_work = 0
      if (obj.check == 1) {
        obj.formal_work = 1
      }
      if (obj.check == 2) {
        obj.week_work = 1
      }
      return obj
    },
    fnGetWorkType(check) {
      if (check == 1) {
        return 'formal_work'
      } else if (check == 2) {
        return 'week_work'
      } else {
        return 'clear'
      }
    },
    setCalandarType(dateT) {
      event.stopPropagation()
      event.preventDefault()
      this.$confirm('是否确定修改?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // this.calandarData[dateT] = this.filterStuatsRestore(this.calandarData[dateT])
        this.fnSubmitConfirm(dateT)
      }).catch(() => {
        this.calandarData[dateT].check = this.filterStatus(this.calandarData[dateT])
      })
    },
    fnSubmitConfirm: function(dateT) {
      const postForm = {
        day: dateT.replace(/-/g, ''),
        workType: this.fnGetWorkType(this.calandarData[dateT].check)
      }
      this.$http.setCalendarData(postForm).then(res => {
        if (res.code == 200) {
          this.getCalendarData()
        }
      })
    },
    fnSetNewCalandarType(dateT) {
      this.$set(this.calandarData, dateT, {
        formal_work: 0,
        week_work: 0,
        check: '3'
      })
      // this.calandarData[dateT].check = this.filterStatus(this.calandarData[dateT])
    },
    fnRefreshCorrectTime() {
      this.$confirm('是否刷新时间?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.syncCorrectWorkDay().then(res => {
          if (res.code == 200) {
            this.$message.success('刷新成功！')
          }
        })
      }).catch(() => {

      })
    },
    fnGetHolidayCheck: function(time) {
      var months = moment(time).format('MM-DD')
      var isWeek = moment(time).days() == 6 || moment(time).days() == 0
      if (this.holidayJson[months] && !this.holidayJson[months].holiday) {
        return '1'
      } else if (this.holidayJson[months] && this.holidayJson[months].holiday) {
        return '2'
      } else if (isWeek) {
        return '2'
      } else {
        return '1'
      }
    },
    fnGetWorkTypeByDate: function(time) {
      var checkNum = this.fnGetHolidayCheck(time)

      return checkNum
    },
    fnSetCurrentMonth: function() {
      if (JSON.stringify(this.holidayJson) == '{}') {
        alert(`没有${this.currentYear}年的节假日数据 获取地址：https://timor.tech/api/holiday/year/${this.currentYear}`)
      }
      var setLists = this.getDatesInCurrentMonth()
      var self = this
      async.map(setLists, function(time, next) {
        var checkNum = self.fnGetWorkTypeByDate(time)
        const postForm = {
          day: time.replace(/-/g, ''),
          workType: self.fnGetWorkType(checkNum)
        }
        self.$http.setCalendarData(postForm).then(res => {
          if (res.code == 200) {
            self.$set(self.calandarData, time, {
              formal_work: checkNum == '1' ? 1 : 0,
              week_work: checkNum == '2' ? 1 : 0,
              check: checkNum
            })
            next(null)
          }
        })
      }, function() {
        console.log(self.calandarData)
      })
    },

    getDatesInCurrentMonth: function() {
      var datesInMonth = []
      var currentDate = moment(this.date).startOf('month')
      var endDateOfMonth = moment(this.date).endOf('month')
      // eslint-disable-next-line no-unmodified-loop-condition
      while (currentDate <= endDateOfMonth) {
        datesInMonth.push(moment(currentDate).format('YYYY-MM-DD'))
        currentDate.add(1, 'days')
      }
      return datesInMonth
    },
    setIsHoliday(date, val) {
      this.calandarData[date].is_holiday = val == '0' ? '1' : '0'
      this.$http.setHoliday({
        day: date.replace(/-/g, ''),
        is_holiday: val
      }).then(res => {
        if (res.code == 200) {
          this.$message.success('设置成功')
          this.calandarData[date].is_holiday = val
        }
      })
    }

  }
}
</script>

<style lang="scss" scope>
  .warning_tips {
    padding-left:10px;
    color:red;
    padding-top: 10px;
  }
  .calandar_new .el-radio {
    width: 100%;
  }

.calandar_new .normal .el-radio__input.is-checked + .el-radio__label {
  color: #4c84ff !important;
}
/* 选中后小圆点的颜色 */
.calandar_new .normal .el-radio__input.is-checked .el-radio__inner {
  background: #4c84ff !important;
  border-color: #4c84ff !important;
}
  .calandar_new .el-radio__input + .el-radio__label {
    color:#999999
  }
  .calandar_new .week .el-radio__input.is-checked + .el-radio__label {
  color: #009688 !important;
}
/* 选中后小圆点的颜色 */
.calandar_new .week .el-radio__input.is-checked .el-radio__inner {
  background: #009688 !important;
  border-color: #009688 !important;
}

.calandar_new .none .el-radio__input.is-checked + .el-radio__label {
  color: #999999 !important;
}
/* 选中后小圆点的颜色 */
.calandar_new .none .el-radio__input.is-checked .el-radio__inner {
  background: #999999 !important;
  border-color: #999999 !important;
}

  .el-calendar-table .el-calendar-day{
    height: auto!important;

  }
  .el-calendar-day p {
    font-weight: normal!important;
  }
  .current .el-calendar-day p {
    color:#333333;

  }
  .prev .el-calendar-day p {
    color:#999999
  }
  .set-working-day {
    background: white;
    padding: 10px;
  }

</style>
